import moment from 'moment';

export const isNight = () => {
	const hours = moment().hours();
	return hours < 6 || hours >= 18;
};

export const isFrontpage = () => {
	return window.location.pathname === '/';
};
